module.exports = __webpack_public_path__ + "img/Energem_80X30.1bd10e86.png";